import type { AxiosInstance } from 'axios';
import { CreateChartRecord, UpdateChartRecordOverride } from './interfaces/chat';

export class ChatChartPreferencesClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  createChartRecord = (data: CreateChartRecord.Request) => {
    return this.authenticatedClient
      .put<CreateChartRecord.Response>(`/chat/chart-records`, data)
      .then(response => response.data);
  };

  updateChartRecordOverride = ({ recordId, ...data }: UpdateChartRecordOverride.Request) => {
    return this.authenticatedClient
      .post<UpdateChartRecordOverride.Response>(`/chat/chart-records/${recordId}/override`, data)
      .then(response => response.data);
  };
}